var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("h1", [_vm._v("Авторизация")]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticStyle: { margin: "6px 0 0" },
          attrs: { inline: true, model: _vm.form, rules: _vm.loginRules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "login" } },
            [
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: { placeholder: "Логинн" },
                model: {
                  value: _vm.form.login,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "login", $$v)
                  },
                  expression: "form.login",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: { placeholder: "Пароль", type: "password" },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.userLogin } },
                [_vm._v("Войти")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }